module.exports = __webpack_public_path__ + "img/vincent_h.560be013.png";